import { CalendarStyles } from './Calendar.types'

const makeStyles = (): CalendarStyles => ({
	calendar: {
		border: '1px solid black',
		margin: '0px 10px 15px'
	}
})

export default makeStyles
